<template>
  <div class="Visualizer">
      <div class="bg-black p-2 rounded">
        <!-- Header -->
        <div class="row">
          <div class="col-md-2">
            <div class="input-group flex-nowrap">
              <input class="btn bg-black text-white fw-light fs-2 rounded w-100" style="width: 200px; margin-top: -4px; cursor: default; letter-spacing: 5px;" type="text" value="Visualizer" readonly>
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group flex-nowrap">
              <button class="btn btn-fluxity w-25 fs-3 me-1" @click="getReporters" :disabled="gettingReporters || processing">
                <i class="fa-solid fa-circle-nodes" :class="{'fa-spin': gettingReporters}"></i>
              </button>
              <select class="btn btn-fluxity w-75" v-model="reporter" :disabled="gettingReporters || processing" @change="clean">
                <option :value="null">Select reporter.</option>
                <option :value="_reporter.name" v-for="(_reporter, ri) in reporters" :key="ri">{{_reporter.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group flex-nowrap">
              <button class="btn btn-fluxity w-25 fs-3 me-1" :disabled="gettingReporters || processing">
                <i class="fa-solid fa-cube"></i>
              </button>
              <select class="btn btn-fluxity w-75" v-model="toptype" :disabled="gettingReporters || processing" @change="clean">
                <option :value="null">Select type.</option>
                <option :value="_toptype" v-for="(_toptype, ti) in toptypes" :key="ti">{{_toptype.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group flex-nowrap">
              <button class="btn btn-fluxity w-25 fs-3 me-1" :disabled="gettingReporters || processing">
                <i class="fa-solid fa-calendar"></i>
              </button>
              <select class="btn btn-fluxity w-75" v-model="period" :disabled="gettingReporters || processing" @change="clean">
                <option :value="null">Select period.</option>
                <option :value="_period.value" v-for="(_period, pi) in periods" :key="pi">{{_period.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-1">
            <div class="input-group flex-nowrap">
              <button class="btn btn-fluxity w-100 fs-3 me-1" :disabled="gettingReporters || processing || this.reporter == null || this.toptype == null || this.period == null" @click="getTopData(); clean(); actionMessage='Getting data, please wait.';">
                <i class="fa-solid fa-magnifying-glass"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Sections -->
      <div class="bg-black p-2 rounded mt-2" style="height: 590px;">
          <!-- Rest Area -->
          <div v-show="section=='restarea'" class="fs-3 text-white">
            <div style="margin-top: 17%;">
                <i class="fa-solid fa-xl fa-gear" :class="{'fa-spin': processing }"></i>
                <p class="text-white fw-light fa-fade">{{actionMessage}}</p>
            </div>
          </div>
          <!-- Graph & List -->
          <div class="" v-show="section=='data'" style="height: 580px;">
            <div class="row">
              <div class="col-md-1">
                <button class="btn btn-fluxity w-100 fs-3 me-1" @click="mode=!mode">
                  <i class="fa-solid" :class="{'fa-list': mode==0, 'fa-chart-pie': mode==1}"></i>
                </button>
                <button class="btn btn-fluxity w-100 fs-3 mt-2" @click="getTopDataExcel">
                  <i class="fa-solid fa-file-excel"></i>
                </button>
                <button class="btn btn-fluxity w-100 fs-3 mt-2" @click="clean">
                  <i class="fa-solid fa-broom"></i>
                </button>
                <button v-if="mode==1" class="btn w-100 fs-3 mt-2" :class="{'btn-fluxity': highlight, 'btn-dark': !highlight }" @click="highlight = !highlight">
                  <i class="fa-solid fa-lightbulb"></i>
                </button>
              </div>
              <div class="col-md-11">
                <!-- Graph -->
                <div v-if="mode==0" style="height: 100%;">
                  <div class="p-1 rounded" style="height: 100%;" v-if="topdata.graph_data != null">
                    <TDChart chart-id="top_data_chart" :chart-data="topdata.graph_data"></TDChart>
                  </div>
                </div>
                <!-- List -->
                <div v-if="mode==1" style="height: 100%;">
                  <div class="p-1 rounded" style="height: 100%;" v-if="topdata.data != null">
                    <div class="input-group flex-nowrap">
                      <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 60%;">
                        <i class="fa-solid fa-id-badge"></i>
                      </button>
                      <button v-if="toptype!=null" class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 30%;">
                        <span v-if="toptype.name=='Talkers' || toptype.name=='Flows' ">Mbps</span>
                        <span v-if="toptype.name=='Ports'">Count</span>
                      </button>
                      <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 10%;">
                        <i class="fa-solid fa-eye"></i>
                      </button>
                    </div>
                    <div class="" style="height: 500px; overflow-y: scroll;" :class="{'disabled-div': gettingDetail}">
                      <div class="input-group flex-nowrap mt-1" :class="{'row-fluxity': highlight}" style="border-bottom: solid rgb(20,20,20) 1px;" v-for="(_data, di) in topdata.data" :key="di">
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 60%;" :value="_data.name" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: default; width: 30%;" :value="_data.size" readonly>
                        <button class="btn text-white fs-3 btn-fluxity me-1 rounded" style="width: 10%;" @click="getTDDetail(_data)">
                          <i class="fa-solid fa-eye"></i>
                        </button>
                        <button id="ombtn" style="display:none;" data-bs-toggle="modal" data-bs-target="#td_detail" ></button>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <!-- Top Data Element Detail -->      
      <div class="modal fade" id="td_detail" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content bg-black">
                  <div class="modal-header border-0">
                      <div v-if="topdata.data!=null & tde!=null" class="input-group flex-nowrap">
                        <button class="btn btn-fluxity rounded fs-2">
                          {{topdata.data.indexOf(tde) + 1}}
                        </button>
                        <input type="text" class="btn text-white border-top-fluxity border-bottom-fluxity rounded text-start w-100 fs-4" style="cursor: text;" :value="tde.name" readonly>
                        <button class="btn rounded fs-2 me-2" :class="{'btn-fluxity': highlight, 'btn-dark': !highlight }" @click="highlight = !highlight">
                          <i class="fa-solid fa-lightbulb"></i>
                        </button>
                        <button class="btn btn-fluxity rounded fs-2 me-2" @click="getDetailFile">
                          <i class="fa-solid fa-file-export"></i>
                        </button>
                        <button class="btn btn-danger fs-2 rounded" data-bs-dismiss="modal">
                          <i class="fa-solid fa-close"></i>
                        </button>
                      </div>
                  </div>
                  <div class="modal-body">
                      <div v-if="tde!=null" class="input-group flex-nowrap">
                        <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 50%;">
                          <i class="fa-solid fa-id-badge"></i>
                        </button>
                        <button v-if="toptype!=null" class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 20%;">
                          Value (Mbps)
                        </button>
                        <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 30%;">
                          <i class="fa-solid fa-calendar"></i>
                        </button>
                      </div>
                      <div class="input-group flex-nowrap" :class="{'row-fluxity': highlight}" v-for="(_det, dti) in tde_detail" :key="dti">
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 50%;" :value="_det.name" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 20%;" :value="`${_det.value}`" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 30%;" :value="_det.timestamp" readonly>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!-- Form to generate the top data txt file -->
      <form :action="file_action_td" method="GET" id="td_form" target="formware" style="display: none">
          <input type="text" name="unique" v-model="unique" readonly>
          <input type="text" name="reporter" v-model="reporter" readonly>
          <input v-if="toptype  != null" type="text" name="route" v-model="toptype.value" readonly>
          <input v-if="period  != null" type="text" name="period" v-model="period" readonly>
          <input v-if="toptype != null" type="text" name="type"   v-model="toptype.single" readonly>
          <input v-if="tde     != null" type="text" name="name"   v-model="tde.name" readonly>
      </form>

      <!-- Form to generate the detail txt file -->
      <form :action="file_action" method="GET" id="df_form" target="formware" style="display: none">
          <input type="text" name="unique" v-model="unique" readonly>
          <input type="text" name="reporter" v-model="reporter" readonly>
          <input v-if="toptype != null" type="text" name="type" v-model="toptype.single" readonly>
          <input v-if="tde != null"  type="text" name="name" v-model="tde.name" readonly>
      </form>

      <!-- Target of all the download forms-->
      <iframe name="formware" id="formware" frameborder="0" style="display: none;"></iframe>


  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'
import TDChart from '@/components/apps-components/fluxity/subs/charts/TDChart.vue'

import axios from "axios";

export default {
  name: 'Visualizer',
  components: {
    TDChart
  },
  data(){
    return {
      // General
      appclient: null,
      site: null,
      stage: null,
      section: 'restarea',
      mode: 0, // 0  = Graph ,  1 = List
      processing: false,
      unique: null,
      start: null,
      // Reporters
      gettingReporters: false,
      reporters: [],
      reporter: null,
      // Toptypes
      toptypes: [
        {
          name: 'Talkers',
          single: 'talker',
          value: 'getTopTalkers'
        },
        {
          name: 'Flows',
          single: 'flow',
          value: 'getTopFlows'
        },
        {
          name: 'Ports',
          single: 'port',
          value: 'getTopPorts'
        },

      ],
      toptype: null,
      // Periods 5-minute, 15-minute, 1-hour, 1-day
      periods: [
        {
          name: "5 Minutes.",
          value: "5-minute"
        },
        {
          name: "15 Minutes.",
          value: "15-minute"
        },
        {
          name: "1 Hour.",
          value: "1-hour"
        },
        {
          name: "1 Day.",
          value: "1-day"
        }
      ],
      period: null,
      // Top Data
      topdata: {
        data: null,
        graph_data: null
      },
      tde: null,
      tde_detail: [],
      gettingDetail: false,

      highlight: false,
      action: "default",
      actionMessage: "Set parameters and get statistics."
    }
  },
  methods:{
    
    // Reporters
    getReporters(){
      this.gettingReporters = true
      this.reporter = null
      const params = {}
      const dest = this.site + '/fluxity/visualizer/getReporters'
      axios
          .get(dest, {params})
          .then(rx => {
              this.reporters = rx.data
              this.gettingReporters = false
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.gettingReporters = false
          });
    },

    // Top Data
    getTopData(){
      this.processing = true
      this.actionMessage = "Processing request..."
      const params = {reporter: this.reporter, route: this.toptype.value, period: this.period}
      const dest = this.site + '/fluxity/visualizer/getTopData'
      axios
          .get(dest, {params})
          .then(rx => {
              this.topdata.graph_data = rx.data.graph_data
              this.topdata.data = rx.data.data
              this.processing = false
              this.section = 'data'
          })
          .catch(error => {
            console.log(error)
              this.processErrorMessage(error)
              this.processing = false
          });
    },
    getTopDataExcel(){
      this.setUnique()
      if ( !confirm('Download top data excel?') ){
          return
      }
      td_form.submit()
    },

    getTDDetail(_element){
      this.tde = _element
      // Sending
      this.gettingDetail = true
      const params = {reporter: this.reporter, type: this.toptype.single, name: _element.name}
      const dest = this.site + '/fluxity/visualizer/getTopDataDetail'
      axios
          .get(dest, {params})
          .then(rx => {
              this.gettingDetail = false
              this.tde_detail = rx.data.data
              document.getElementById('ombtn').click()
          })
          .catch(error => {
            console.log(error)
              this.processErrorMessage(error)
              this.gettingDetail = false
          });
    },

    setUnique(){
        var date = new Date();
        this.unique = date.getTime()
    },
    getDetailFile(){
      this.setUnique()
      if ( !confirm('Download detail excel?') ){
          return
      }
      df_form.submit()
    },


    clean(){
      this.topdata = { data: null, graph_data: null }
      this.mode = 0
      this.section = 'restarea'
      this.actionMessage = "Set parameters and get flows."
      this.tde = null
    },


    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.error
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.error
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    //this.appServiceUrl = this.appServiceUrl.replace('_CLIENT_NAME_', this.appclient)
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.setUnique()
    this.file_action_td = `${this.site}/fluxity/visualizer/getTopDataExcel`
    this.file_action= `${this.site}/fluxity/visualizer/getTopDataDetailExcel`
  },
  mounted: function(){
    this.getReporters()
  }
}
</script>

<style scoped>
  
  .btn-fluxity{
    background-color: rgb(255, 89, 0);
    transition-duration: 0.7s;
    color: white;
  }
  .btn-fluxity:hover{
    background-color: rgb(186, 65, 0);
  }
  .border-fluxity{
    border: solid 4px rgb(255, 89, 0);
  }
  .border-bottom-fluxity{
    border-bottom: solid 2px rgb(255, 89, 0);
  }
  .border-top-fluxity{
    border-top: solid 2px rgb(255, 89, 0);
  }
  .row-fluxity{
    transition-duration: 0.7s;
    opacity: 0.3;
  }
  .row-fluxity:hover{
    opacity: 1.0;
  }

  .disabled-div{
      pointer-events: none;
      opacity: 0.5;
  }




  /* Scrollbar */
  /* width */
  ::-webkit-scrollbar {
      width: 10px;
      height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgb(37, 33, 33); 
      border-radius: 10px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: rgb(64, 133, 88); 
      border-radius: 10px;
      transition-duration: 2.0s;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: rgb(54, 112, 75); 
  }

</style>
